/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StakeholderDTO
 */
export interface StakeholderDTO {
    /**
     * 
     * @type {boolean}
     * @memberof StakeholderDTO
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    contactPerson?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    fiscalId?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StakeholderDTO
     */
    isCustomer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StakeholderDTO
     */
    isManufacturer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StakeholderDTO
     */
    isOwner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StakeholderDTO
     */
    isSupplier?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    paymentCurrency?: StakeholderDTOPaymentCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    paymentTerms?: StakeholderDTOPaymentTermsEnum;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderDTO
     */
    postalCode?: string;
}


/**
 * @export
 */
export const StakeholderDTOPaymentCurrencyEnum = {
    Dollar: 'DOLLAR',
    Euro: 'EURO',
    PoundSterling: 'POUND_STERLING'
} as const;
export type StakeholderDTOPaymentCurrencyEnum = typeof StakeholderDTOPaymentCurrencyEnum[keyof typeof StakeholderDTOPaymentCurrencyEnum];

/**
 * @export
 */
export const StakeholderDTOPaymentTermsEnum = {
    Cash: 'CASH',
    Net30: 'NET30',
    Net60: 'NET60',
    Net90: 'NET90'
} as const;
export type StakeholderDTOPaymentTermsEnum = typeof StakeholderDTOPaymentTermsEnum[keyof typeof StakeholderDTOPaymentTermsEnum];


/**
 * Check if a given object implements the StakeholderDTO interface.
 */
export function instanceOfStakeholderDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StakeholderDTOFromJSON(json: any): StakeholderDTO {
    return StakeholderDTOFromJSONTyped(json, false);
}

export function StakeholderDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StakeholderDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'contactPerson': !exists(json, 'contactPerson') ? undefined : json['contactPerson'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'fiscalId': !exists(json, 'fiscalId') ? undefined : json['fiscalId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isCustomer': !exists(json, 'isCustomer') ? undefined : json['isCustomer'],
        'isManufacturer': !exists(json, 'isManufacturer') ? undefined : json['isManufacturer'],
        'isOwner': !exists(json, 'isOwner') ? undefined : json['isOwner'],
        'isSupplier': !exists(json, 'isSupplier') ? undefined : json['isSupplier'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'paymentCurrency': !exists(json, 'paymentCurrency') ? undefined : json['paymentCurrency'],
        'paymentTerms': !exists(json, 'paymentTerms') ? undefined : json['paymentTerms'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
    };
}

export function StakeholderDTOToJSON(value?: StakeholderDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'address': value.address,
        'city': value.city,
        'code': value.code,
        'comment': value.comment,
        'contactPerson': value.contactPerson,
        'country': value.country,
        'email': value.email,
        'fiscalId': value.fiscalId,
        'id': value.id,
        'isCustomer': value.isCustomer,
        'isManufacturer': value.isManufacturer,
        'isOwner': value.isOwner,
        'isSupplier': value.isSupplier,
        'name': value.name,
        'paymentCurrency': value.paymentCurrency,
        'paymentTerms': value.paymentTerms,
        'phone': value.phone,
        'postalCode': value.postalCode,
    };
}

